import React from 'react';
import { CategoryFilterDropdown } from '../../components/transactions/CategoryFilterDropdown';
import { AccountFilterDropdown } from '../../components/transactions/AccountFilterDropdown';
import type { ReportFilters } from '../../types/report.types';

interface Props {
  filters: ReportFilters;
  onChange: (filters: ReportFilters) => void;
}

export function ReportWizardStepFilters({ filters, onChange }: Props): React.ReactElement {
  const categoryIds = filters.categoryIds ?? [];
  const accountIds = filters.accountIds ?? [];

  return (
    <div className="space-y-5">
      <div>
        <label className="mb-2 block text-sm font-medium text-gray-700">Select Categories</label>
        <CategoryFilterDropdown
          value={categoryIds}
          onChange={(ids) => onChange({ ...filters, categoryIds: ids })}
          aria-label="Select categories for report"
        />
        <p className="mt-1.5 text-xs text-gray-500">
          {categoryIds.length === 0
            ? 'No categories selected will include all category data.'
            : `${categoryIds.length} categor${categoryIds.length === 1 ? 'y' : 'ies'} selected`}
        </p>
      </div>

      <div>
        <label className="mb-2 block text-sm font-medium text-gray-700">Select Accounts</label>
        <AccountFilterDropdown
          value={undefined}
          valueIds={accountIds}
          onChange={() => {}}
          onChangeIds={(ids) => onChange({ ...filters, accountIds: ids })}
        />
        <p className="mt-1.5 text-xs text-gray-500">
          {accountIds.length === 0
            ? 'No accounts selected will include all account data.'
            : `${accountIds.length} account${accountIds.length === 1 ? '' : 's'} selected`}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label htmlFor="min-amount" className="mb-1 block text-sm font-medium text-gray-700">
            Minimum amount
          </label>
          <input
            id="min-amount"
            type="number"
            min={0}
            step="0.01"
            placeholder="Minimum amount"
            value={filters.minAmount ?? ''}
            onChange={(e) =>
              onChange({
                ...filters,
                minAmount: e.target.value ? Number(e.target.value) : null,
              })
            }
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label htmlFor="max-amount" className="mb-1 block text-sm font-medium text-gray-700">
            Maximum amount
          </label>
          <input
            id="max-amount"
            type="number"
            min={0}
            step="0.01"
            placeholder="Maximum amount"
            value={filters.maxAmount ?? ''}
            onChange={(e) =>
              onChange({
                ...filters,
                maxAmount: e.target.value ? Number(e.target.value) : null,
              })
            }
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
          />
        </div>
      </div>

      <div>
        <label htmlFor="keywords" className="mb-1 block text-sm font-medium text-gray-700">
          Keyword Filters
        </label>
        <input
          id="keywords"
          type="text"
          placeholder="Enter merchant names or note keywords"
          value={filters.keywords ?? ''}
          onChange={(e) => onChange({ ...filters, keywords: e.target.value || null })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
        />
      </div>
    </div>
  );
}
